import { IPlayerStateTaskData } from '../../../State/Player/IPlayerState';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { PlayerTask } from '../../../State/Player/PlayerTasks';
import ITask from '../../../Utility/Task/ITask';
import WorldSystem from '../WorldSystem';
import RewardAnimationHelper from './RewardAnimationHelper';

export default class RewardSyncTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<number> {
        const state = system.state.getState().playerState;

        // Take a copy of the state tasks.
        let tasks = state.tasks.slice(0);

        if (tasks && tasks.length > 0) {
            // Overwrite tasks with potentially merged tasks.
            tasks = this.mergeTasks(tasks);

            for (const taskData of tasks) {
                switch (taskData.task) {
                    case PlayerTask.EARN_COINS:
                        RewardAnimationHelper.earnCoins(system, taskData);
                        break;
                    case PlayerTask.SPEND_COINS:
                        RewardAnimationHelper.spendCoins(system, taskData);
                        break;
                    case PlayerTask.LIVE:
                        RewardAnimationHelper.lives(system, taskData);
                        break;
                    case PlayerTask.KEY:
                        RewardAnimationHelper.keys(system, taskData);
                        break;
                    case PlayerTask.TNT:
                        RewardAnimationHelper.boosterTNT(system, taskData);
                        break;
                    case PlayerTask.BULLS_EYE:
                        RewardAnimationHelper.boosterBullsEye(system, taskData);
                        break;
                    case PlayerTask.SHUFFLE:
                        RewardAnimationHelper.boosterShuffle(system, taskData);
                        break;
                    case PlayerTask.JOKER:
                        RewardAnimationHelper.jokers(system, taskData);
                        break;
                    case PlayerTask.EXTRA_CARDS:
                        RewardAnimationHelper.extraCards(system, taskData);
                        break;
                    case PlayerTask.UNLOCK_BACKCARD:
                        RewardAnimationHelper.unlockBackcard(system, taskData);
                        break;
                    case PlayerTask.LEVEL_NODE_COMPLETE:
                        // prettier-ignore
                        RewardAnimationHelper.levelNodeComplete(system, taskData);
                        break;
                    case PlayerTask.CREATE_SHORTCUT:
                        // prettier-ignore
                        RewardAnimationHelper.createShortcut(system, taskData);
                        break;
                }
            }

            system.state.dispatch(PlayerActions.clearTasks());
        }
    }

    private mergeTasks(tasks: IPlayerStateTaskData[]): IPlayerStateTaskData[] {
        return tasks.reduce<IPlayerStateTaskData[]>(
            (previousValue, currentValue) => {
                if (currentValue && currentValue.task === PlayerTask.EARN_COINS) {
                    const coinsTask = previousValue.find(
                        t => t.task === PlayerTask.EARN_COINS
                    );
                    if (coinsTask !== undefined) {
                        coinsTask.coins += currentValue.coins;
                    } else {
                        previousValue.push(currentValue);
                    }
                } else {
                    previousValue.push(currentValue);
                }

                return previousValue;
            },
            []
        );
    }
}
